import { CrystalMark, StarIcon } from '@/assets/icons';
import { StatusChip } from '@/components/StatusChip';
import { formatOrderDate } from '@/utils/format';
import type { Order } from '@/types/order';
import styles from './OrderRow.module.scss';

export interface OrderRowProps {
  order: Order;
}

function recipientLabel(order: Order): string {
  if (order.recipient.type === 'gift' && order.recipient.username) {
    return `Gift to @${order.recipient.username}`;
  }
  return 'For yourself';
}

export function OrderRow({ order }: OrderRowProps) {
  return (
    <div className={styles.row}>
      <div className={styles.icon}>
        {order.productCategory === 'premium' ? <CrystalMark size={19} /> : <StarIcon size={19} />}
      </div>
      <div className={styles.mid}>
        <div className={styles.title}>{order.productTitle}</div>
        <div className={styles.sub}>
          {formatOrderDate(order.createdAt)} · {recipientLabel(order)}
        </div>
      </div>
      <div className={styles.right}>
        <div className={styles.amount}>{order.amountLabel}</div>
        <StatusChip status={order.status} />
      </div>
    </div>
  );
}
